import type { AuthRepository, TokenPair } from '@contexts/auth/domain';
import type { UseCase } from '@contexts/shared/application';
import { stringValueObject } from '@contexts/shared/domain';

export type SuplantUserByDeviceIdentificatorInput = {
	deviceIdentificator: string;
};

export type SuplantUserByDeviceIdentificatorUseCase = UseCase<
	SuplantUserByDeviceIdentificatorInput,
	TokenPair
>;

export function suplantUserByDeviceIdentificatorBuilder(
	authRepository: AuthRepository
): SuplantUserByDeviceIdentificatorUseCase {
	return async function suplantUserByDeviceIdentificator(
		input: SuplantUserByDeviceIdentificatorInput
	): Promise<TokenPair> {
		const deviceIdentificator = stringValueObject().validate(
			'deviceIdentificator',
			input.deviceIdentificator
		);

		return authRepository.suplantUserByDeviceIdentificator(deviceIdentificator);
	};
}
